import React, { ReactElement } from 'react';

import classNames from 'classnames';
import { getAcronymFromName } from '../../libs/getAcronymName';
import { Country } from '../../types';
import styles from './CountryFlagWithName.module.scss';

export const CountryFlagWithName = ({ name, flagUrl }: Country['nameWithFlag']): ReactElement | null => {
  return (
    <div className={styles.container}>
      <div>
        {flagUrl ? (
          <img src={flagUrl} alt="flag" className={styles.flagBlock} />
        ) : (
          <div className={classNames(styles.flagBlock, styles.acronym)}>{getAcronymFromName(name)}</div>
        )}
      </div>
      <span className={styles.name}>{name}</span>
    </div>
  );
};
